export default "__VITE_ASSET__E4oU0Zu8__"